<app-modal
  #deleteCommentModal
  [modalMessage]="app.text.post.deleteCommentQuestion"
  [modalTitle]="app.text.post.modalTitle"
  (ok)="app.OCComment.deleteComment(app.OCComment.selectedComment)"
></app-modal>
<app-modal
  #discardChangesModal
  [modalMessage]="app.text.app.discardChanges"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="app.OCComment.discardChanges()"
  >
</app-modal>

<div class="row">
  <div class="col-md-2 col-sm-2 col-xl-2">
    <!-- Image -->
    <img
      class="profile-image float-end"
      [src]="
        app.profile.ownProfilePicture != null
          ? app.file.getUrl(app.profile.ownProfilePicture)
          : app.url.profile.defaultImage
      "
      />
  </div>
  <div class="col-md-8 col-sm-8 col-xl-8 mb-2 px-0">
    <div class="comment-input">
      <textarea
        #commentTextarea
        [(ngModel)]="app.OCComment.commentDoc['message']"
        placeholder="Share your thoughts on this post"
        class="comment-text"
        rows="1"
        (input)="autoGrow(commentTextarea)"
      ></textarea>

      <button
        type="button"
        (click)="sendComment(commentTextarea)"
        class="btn-send"
        [disabled]="
          app.OCComment.commentDoc['message'] === '' ||
          app.OCHome.editedId !== ''
        "
        >
        <i class="fa-solid fa-paper-plane-top"></i>
      </button>
    </div>
  </div>
  <div class="col-md-2 col-sm-2 col-xl-2"></div>
</div>
@for (comment of app.OCComment.comments; track comment) {
  <div>
    <div class="row">
      <!-- Image -->
      <div class="col-md-2 col-sm-2 col-xl-2">
        @if (comment.avatar != '') {
          <img
            class="profile-image float-end"
            target="_blank"
            [src]="app.file.getUrl(comment.avatar)"
            />
        }
        @if (comment.avatar === '') {
          <img
            class="profile-image float-end"
            target="_blank"
            [src]="app.url.profile.defaultImage"
            />
        }
      </div>
      <!-- Comment content -->
      <div class="col-md-8 col-sm-8 col-xl-8 px-0 mb-2 input readMode">
        <div class="d-flex">
          @if (comment.userFirstName === '' || comment.userLastName === '') {
            <span
              ><b>{{ comment.user_id }}</b></span
              >
            }
            @if (comment.userFirstName !== '' && comment.userLastName !== '') {
              <span
                ><b>{{ comment.userFirstName }} {{ comment.userLastName }}</b></span
                >
              }
              @if (comment.userBadges) {
                <span>
                  @for (badge of comment.userBadges; track badge) {
                    <span
                      >&nbsp;
                      <i
                        class="fa-solid fa-medal fa-fw"
                        [style.color]="app.OCHome.setBadgeColor(badge)"
                        [ngbTooltip]="app.OCHome.setBadgeTooltip(badge)"
                      ></i>
                    </span>
                  }
                </span>
              }
              <div class="controls-text ms-auto">
                {{ app.OCHome.getTimeInfo(comment.create_time) }}
              </div>
            </div>
            @if (comment._id !== app.OCHome.editedId) {
              <div class="text">
                <slot>
                  <div
                    class="fake-textarea"
                    [innerHtml]="app.field.highlightLinks(comment.message)"
                  ></div>
                </slot>
              </div>
            }
            @if (comment._id === app.OCHome.editedId) {
              <textarea
                [(ngModel)]="app.OCComment.cleanComment.message"
                type="text"
                class="comment-text comment-input edit-mode w-100"
              ></textarea>
            }
            <app-attachments
              [id]="comment._id"
              type="ocComment"
              [editPermission]="app.OCHome.hasEditPermission(comment)"
              [files]="comment._attachments"
              [filesDetails]="comment.attachmentHistory"
            ></app-attachments>
          </div>
          <!-- Comment controls -->
          <div class="col-md-2 col-sm-2 col-xl-1">
            <!-- Read mode -->
            @if (comment._id !== app.OCHome.editedId) {
              <div
                class="d-flex flex-column"
                >
                @if (app.OCHome.hasEditPermission(comment)) {
                  <div>
                    <button
                      class="btn btn-control"
            (click)="
              app.OCComment.selectedComment = comment;
              app.OCHome.editDoc(comment._id);
              app.OCHome.createCleanModel(comment)
            "
                      >
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      class="btn btn-control"
                      [title]="app.text.post.delete"
            (click)="
              app.OCComment.selectedComment = comment; deleteCommentModal.open()
            "
                      >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                }
                @if (app.OCHome.hasEditPermission(comment)) {
                  <div class="ms-1">
                    <app-attachments-controls
                      [id]="comment._id"
                      [isColored]="false"
                      type="ocComment"
                    ></app-attachments-controls>
                  </div>
                }
              </div>
            }
            <!-- Edit mode -->
            @if (comment._id === app.OCHome.editedId) {
              <div>
                <button
                  class="btn btn-sm btn-control"
                  (click)="app.OCComment.updateComment()"
                  [title]="app.text.thread.save"
                  [disabled]="app.OCComment.modelHasChanges()"
                  >
                  <i class="fa fa-check save-icon"></i>
                </button>
                <button
                  class="btn btn-sm btn-control"
                  (click)="discardChangesModal.open()"
                  >
                  <i class="fas fa-times close-icon"></i>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    }
